const LOGIN_INTENT_STORAGE_KEY = 'notifications.web_push.prompt.login_intent';
const DISMISSED_STORAGE_KEY = 'notifications.web_push.prompt.dismissed';
const SNOOZED_STORAGE_KEY = 'notifications.web_push.prompt.snoozed';

let cachedConsumedLoginIntent: boolean | null = null;

const isBrowser = (): boolean => typeof window !== 'undefined';

export const markWebPushPromptLoginIntent = (): void => {
  if (!isBrowser()) {
    return;
  }

  cachedConsumedLoginIntent = null;
  window.sessionStorage.setItem(LOGIN_INTENT_STORAGE_KEY, '1');
  window.sessionStorage.removeItem(SNOOZED_STORAGE_KEY);
};

export const consumeWebPushPromptLoginIntent = (): boolean => {
  if (!isBrowser()) {
    return false;
  }

  // React.StrictMode double-mounts components in development. Cache the
  // logical consume result so the second mount sees the same login intent.
  if (cachedConsumedLoginIntent !== null) {
    return cachedConsumedLoginIntent;
  }

  const hasIntent =
    window.sessionStorage.getItem(LOGIN_INTENT_STORAGE_KEY) === '1';

  if (hasIntent) {
    window.sessionStorage.removeItem(LOGIN_INTENT_STORAGE_KEY);
  }

  cachedConsumedLoginIntent = hasIntent;
  return hasIntent;
};

export const snoozeWebPushPromptForSession = (): void => {
  if (!isBrowser()) {
    return;
  }

  window.sessionStorage.setItem(SNOOZED_STORAGE_KEY, '1');
};

export const isWebPushPromptSnoozedForSession = (): boolean => {
  if (!isBrowser()) {
    return false;
  }

  return window.sessionStorage.getItem(SNOOZED_STORAGE_KEY) === '1';
};

export const dismissWebPushPromptPermanently = (): void => {
  if (!isBrowser()) {
    return;
  }

  window.localStorage.setItem(DISMISSED_STORAGE_KEY, '1');
};

export const isWebPushPromptPermanentlyDismissed = (): boolean => {
  if (!isBrowser()) {
    return false;
  }

  return window.localStorage.getItem(DISMISSED_STORAGE_KEY) === '1';
};
